module.exports = __webpack_public_path__ + "static/person-ecd21dfc94d5535e802f9a3b6bd1f339.png";